import { useState, useMemo } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import TextEdit from '../CommonComponents/TextEdit';
import { ContentCopy } from '@mui/icons-material';
import { Modal, Switch, Upload, message } from 'antd';
import { isEmpty } from 'lodash';

import 'Styles/commonStyles.scss';
import Input from 'Components/CommonComponents/ReactHooKForm/Input/Input';
import Select from 'Components/CommonComponents/ReactHooKForm/Select/Select';
import Empty from 'Components/CommonComponents/Empty/Empty';
import Button from 'Components/CommonComponents/Button/Button';
import CommunicationService from '../../Services/communicationService';
import { useGetCommunicationTransactions } from 'ServiceHooks/communicationHooks';
import TemplatePreview from './TemplatePreview';
import { DEFAULT_ERROR_MESSAGE } from 'Utilities/constants';
import { FiUpload } from 'react-icons/fi';
import axios from 'axios';
import authHeader from 'Services/authHeader';

var updatedText;
const Email = () => {
  const [getTransactionId, setGetTransactionId] = useState('');
  const [activeForm, setActiveForm] = useState(false);
  const [details, setDetails] = useState();
  const [description, setJobDescription] = useState();
  const [error, setErrorEmail] = useState(false);
  const [isValidateError, setIsisValidateError] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [file, setFile] = useState([]);

  const [messageApi, contextHolder] = message.useMessage();

  const {
    control,
    setValue,
    register,
    setError,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'all',
    defaultValues: {
      email_subject: '',
    },
  });

  const subjectField = useWatch({ control, name: 'email_subject' });

  const emptyBracesRegex = /{\s*}/g;
  const keywordMatchRegex = /{([^{}]+)}/g;

  const onChange = (e) => {
    setJobDescription(e);
  };

  const getFileExtension = (url) => {
    const match = url.match(/\.([a-zA-Z0-9]+)(\?.*)?$/);
    return match ? match[1] : null;
  };

  const getTranscationDetails = async (id) => {
    await CommunicationService.getTranscationDataById(id).then(
      async(response) => {
        console.log(response.data.data,"response.data.data");
        setDetails(response.data.data);
        setValue('email_subject', response?.data?.data?.subject);
        setJobDescription(response?.data?.data?.html_content);
        setRefreshKey((prevKey) => prevKey + 1);
        if(response.data.data?.image){
          const extension = getFileExtension(response.data.data?.image);
          const response_image = await axios({
            method: 'get',
            url: response.data.data?.image,
            responseType: 'blob',
            headers: {
              ...authHeader(),
            },
          });
          
          const file = new File(
            [response_image.data],
            `UploadedFile.${extension}`,
            {
              type: response_image.data.type,
            },
          );
          setFile([file]);
        }
      },
    );
  };

  const handleNameCopy = (item) => {
    updatedText = `{${item}}`;
    navigator.clipboard.writeText(updatedText);
    message.success('Copied');
  };

  const handelReset = async () => {
    await CommunicationService.getRestTransactionById(getTransactionId)
      .then((response) => {
        setDetails(response.data.data);
        setValue('email_subject', response?.data?.data?.subject);
        setJobDescription(response?.data?.data?.html_content);
      })
      .catch((err) => {});
  };

  const { data: transactions } = useGetCommunicationTransactions({});

  const transactionOptions = useMemo(() => {
    if (isEmpty(transactions?.results)) return [];
    const options = transactions?.results?.map((item) => {
      return {
        label: item.value,
        value: item.key,
      };
    });
    return options;
  }, [transactions]);

  const selectTransactionHandler = ({ key }) => {
    setGetTransactionId(key);

    // Form Activate
    if (key === '') {
      setActiveForm(false);
    } else {
      setActiveForm(true);
    }
    getTranscationDetails(key);
  };
  const handleSwtich = async (e) => {
    setDetails((prev)=> {
      return {
        ...prev,
        is_active: e
      }
    })
    await CommunicationService.activeEmailTransaction(getTransactionId, e)
      .then((res) => {})
      .catch((err) => {});
  };

  const filterFile = (file) => {
    //PDF and DOCX might be needed later.
    //Bring in mime-types when API support comes.
    const types = ['.png', '.jpg', '.jpeg', 'image/png', 'image/jpeg'];

    if (types.includes(file.type)) {
      clearErrors('filename');
      setValue('filename', file?.name);
      //AntD's Upload needs arrays.
      setFile([file]);
    } else {
      setError('filename', {
        message: 'Unsupported File Format',
      });
    }

    //Stops AntD's automatic post request
    return false;
  };

  const onSubmit = async (data, e) => {
    const formData = new FormData();
    console.log(file?.length,"filefilefile");
    const values = {
      transaction: getTransactionId,
      email_subject: subjectField,
      content_html: description,
      // image: file && file?.length > 0 ? file[0]: null,
    };

    if(file && file?.length > 0){
      values["image"] = file[0]
    }
    if(details?.id){
      values["id"] = details?.id
    }
    Object.entries(values).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const array = details?.parameters;
    const matches = description?.match(keywordMatchRegex);

    // Test if the input matches the regex pattern
    const emptybracesvalidate = emptyBracesRegex.test(description);
    const isValidSentence = matches?.some((match) => {
      // Remove curly braces from the match
      const element = match.slice(1, -1).trim();
      return !array?.includes(element);
    });

    console.log(file,"filefilefile");

    if (emptybracesvalidate) {
      setErrorEmail(true);
    } else if (isValidSentence === true) {
      setIsisValidateError(true);
    } else if (details?.id == null) {
      try {
        setErrorEmail(false);
        setIsisValidateError(false);
        await CommunicationService.addEmailContent(
          formData
        );

        await messageApi.open({
          type: 'success',
          content: 'Created Successfully',
        });
      } catch (error) {
        await messageApi.open({
          type: 'error',
          content: DEFAULT_ERROR_MESSAGE,
        });
      }
    } else if (details?.id) {
      try {
        setErrorEmail(false);
        setIsisValidateError(false);
        await CommunicationService.editEmailContent(
          formData,
          details?.id,
        );

        await messageApi.open({
          type: 'success',
          content: 'Edited Successfully',
        });
      } catch (error) {
        await messageApi.open({
          type: 'error',
          content: DEFAULT_ERROR_MESSAGE,
        });
      }
    }
  };
  return (
    <div className="w-full">
      <div className="bg-secondaryBgMain rounded-lg mt-4 pb-8">
        <div className="ml-8">
          <form
            className="overflow-y-auto customScrollBar max-h-[65vh]"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="md:flex md:flex-row flex-col flex-wrap">
              <div className="md:w-1/2 px-6 mt-10 rounded-md border border-gray-300">
                <div className="w-full mt-8">
                  <div className="mt-4 w-full">
                    <Select
                      label={'Transaction'}
                      name={'transOption'}
                      placeholder="Select an Option"
                      options={transactionOptions}
                      control={control}
                      onChange={(e) => selectTransactionHandler(e)}
                    />
                  </div>
                  <div className="mt-4 w-full">
                    <Input
                      label={'Subject'}
                      name={'email_subject'}
                      control={control}
                      placeholder={`Add Mail Subject Here`}
                      rules={{
                        validate: {
                          emptyBraces: (value) =>
                            !emptyBracesRegex.test(value) ||
                            'Empty tags are not allowed',
                          invalidBraceContent: (value) => {
                            const matches =
                              value?.match(keywordMatchRegex);
                            const array = details?.parameters;

                            const incorrectTagsDetected = matches?.some(
                              (match) => {
                                // Remove curly braces from the match
                                const element = match.slice(1, -1).trim();

                                return !array?.includes(element);
                              },
                            );

                            if (isEmpty(array) && !isEmpty(matches)) {
                              return 'need keywords to proceed';
                            } else if (incorrectTagsDetected) {
                              return 'some keywords are invalid';
                            } else {
                              return true;
                            }
                          },
                        },
                      }}
                    />
                  </div>
                  <div className="mt-6 w-1/2">
                        <div>
                          Upload Template Image
                          <span
                            className={'text-gray-400 text-sm font-light'}
                          >
                            {'  '}(Accept: .jpeg, .png)
                          </span>
                        </div>
                        <Upload
                          {...register('filename', {
                            required: false,
                          })}
                          type="file"
                          maxCount={1}
                          fileList={file}
                          multiple={false}
                          directory={false}
                          className="w-full"
                          onChange={() => {}}
                          accept=".jpeg, .jpg, .png, image/jpeg, image/png"
                          beforeUpload={(file) => filterFile(file)}
                          onRemove={() => setFile([])}
                        >
                          <Button
                            isCancel
                            className="mt-1"
                            htmlType="button"
                            children={'Upload'}
                            // disabled={isMutating}
                            icon={<FiUpload color="gray" />}
                          />
                        </Upload>
                        {errors?.filename && (
                          <div className="text-[#ff4d4f]">
                            {errors?.filename?.message}
                          </div>
                        )}
                      </div>
                  <div className="w-full mt-8 pb-10">
                    <label className="text-black text-sm font-normal pr-2 pb-2 flex">
                      Content
                    </label>
                    <TextEdit
                      key={refreshKey}
                      id="description"
                      required
                      onChange={onChange}
                      initialValue={
                        details?.html_content ? details?.html_content : ''
                      }
                    />
                    {error && (
                      <p className="text-red-600 text-xs font-semibold text-start">
                        Curly braces cannot be empty
                      </p>
                    )}
                    {isValidateError && (
                      <p className="text-red-600 text-xs font-semibold text-start">
                        Invalid data inside curly braces
                      </p>
                    )}
                  </div>
                  {details && (
                    <div className="flex justify-end mb-4">
                      <Switch
                        checked={details?.is_active}
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        onChange={(e) => handleSwtich(e)}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="md:w-1/2 px-8">
                {activeForm ? (
                  <div className="w-full h-fit p-2 mt-10 rounded-md border-dashed border-gray-300 border-2">
                    <div className="pl-4 w-full flex-col flex mt-6 ">
                      {details &&
                        details.parameters.map((item, index) => (
                          <div>
                            {/* 
                          {index === 0 && (
                            <div className="flex justify-end mb-4">

                              <Switch
                                defaultChecked={item.is_active}
                                checkedChildren="Active"
                                unCheckedChildren="Inactive"
                                onChange={(e) => handleSwtich(e)}
                             
                              />
                            </div>
                          )} */}
                            <div className="flex">
                              <div
                                key={`trans-name-${index}`}
                                className="text-sm w-full px-4 py-2 mb-8 flex bg-white focus:outline-none rounded-md border border-blue-500"
                              >
                                {item}
                              </div>
                              <button
                                type="button"
                                className="text-indigo-300 flex flex-wrap"
                                title="copy"
                                onClick={() => handleNameCopy(item)}
                              >
                                <span className="mt-[6px] ml-[5px]">
                                  <ContentCopy />
                                </span>
                              </button>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    <Empty
                      description={<>{<p> No Selected Transaction</p>}</>}
                    />
                  </div>
                )}
              </div>
            </div>

            <div
              className={`flex text-white text-sm items-center mt-4 font-semibold mr-10 mb-6 ${details?.html_content ? 'justify-between' : 'justify-end'}`}
            >
              {details?.html_content && (
                <Button
                  isSecondary
                  onClick={() => setPreviewOpen(true)}
                  htmlType="button"
                >
                  Preview
                </Button>
              )}
              <div className="flex items-center justify-between">
                {contextHolder}
                <Button
                  isSecondary
                  onClick={handelReset}
                  htmlType="button"
                >
                  Reset
                </Button>
                <Button type="primary" className="ml-4" htmlType="submit">
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {previewOpen && (
        <Modal
          title="Preview"
          open={previewOpen}
          onCancel={() => setPreviewOpen(false)}
          width={1200}
          footer={null}
        >
          <TemplatePreview
            data={details}
            description={description}
            subjectName={subjectField}
            file={file}
          />
        </Modal>
      )}
    </div>
  );
};

export default Email;
